import { useEffect, type ReactNode } from "react";

interface ModalProps {
  /** Becomes the dialog's accessible name. The shell renders no heading of
   *  its own -- callers own their header row. */
  title: string;
  onClose: () => void;
  size?: "normal" | "medium" | "wide";
  children: ReactNode;
}

export function Modal({ title, onClose, size = "normal", children }: ModalProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className={`modal card${size === "normal" ? "" : ` ${size}`}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
